/** @format */

import {TFunction} from 'i18next';

import {AccountsKpiName} from 'graphql/generated/types';

const getKpiTitle = (name: AccountsKpiName, t: TFunction): string => {
  switch (name) {
    case 'DRR':
      return `${t('ДРР')}, %`;
    case 'CPL':
      return 'CPL, ₽';
    case 'VTR':
      return 'VTR, %';
    case 'REVENUE':
      return `${t('Доход')}, ₽`;
    case 'REACH':
      return t('Охват, чел.');
    case 'AVG_VIDEO_COMPLETE_COST':
      return `${t('Ср.цена досмотра ролика')}, ₽`;
    case 'ER':
      return 'ER, %';
    case 'ROMI':
      return 'ROMI, %';
    case 'IMPRESSIONS':
      return t('Показы');
    case 'CPC':
      return 'CPC, ₽';
    case 'CLICKS':
      return t('Клики');
    case 'CPM':
      return 'CPM, ₽';
    default:
      return '';
  }
};

export {getKpiTitle};
